<div class="modal-header">
    <h5 class="modal-title">Select Event</h5>
    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Close click')">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body change-event-dialog">

    <div class="ui-current-events">
        <div (click)="onEventSelect(event)"
             *ngFor="let event of eventService?.events"
             class="event-item gradient-overlay cursor-hand {{event?.cssClass}}">
            <div class="row">
                <div class="col-12">
                    <h3>{{ event?.label }}</h3>
                    <div class="event-date">{{event?.date}} <span class="program">{{event?.programGroupName}}</span></div>
                </div>
            </div>
        </div>
    </div>

    <div *ngIf="eventService?.pastEvents.length > 0" class="ui-past-events">
        <h6><span>Past Events</span></h6>

        <div (click)="onEventSelect(event)" *ngFor="let event of eventService?.pastEvents"
             class="event-item gradient-overlay cursor-hand {{event?.cssClass}}">
            <div class="row">
                <div class="col-12">
                    <h3>{{ event?.label }}</h3>
                    <div class="event-date">{{event?.date}} <span class="program">{{event?.programGroupName}}</span></div>
                </div>
            </div>
        </div>
    </div>

</div>
<div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="activeModal.close('Close click')">Close</button>
</div>